/**
 * Shared refresh cadence for signable eligibility and cross-user execution
 * state. Polling continues while the owning screen is mounted, not only after
 * this browser observes an execution.
 */
export const SIGNABLE_POLL_INTERVAL_MS = 2_000;
